import { render, staticRenderFns } from "./gift-card-recommend.vue?vue&type=template&id=7435972a&scoped=true&"
import script from "./gift-card-recommend.vue?vue&type=script&lang=js&"
export * from "./gift-card-recommend.vue?vue&type=script&lang=js&"
import style0 from "./gift-card-recommend.vue?vue&type=style&index=0&id=7435972a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7435972a",
  null
  
)

export default component.exports